import magnifiAPIInstance from "./apiInstance";

export const xmlFormatsAPIs = {
  getXmlFormats: () => magnifiAPIInstance.get("/get-xml-formats"),
  updateXmlDetails: ({ payload }) => magnifiAPIInstance.post("/update_xml_details", payload),
};
